<template>
    <div class="bg-white rounded-lg shadow p-3">
      <!-- header -->
      <div class="flex items-start justify-between mb-2">
        <div class="text-xs text-gray-600">
          <div class="font-semibold uppercase tracking-wide">
            {{ isOrders ? $t('order') : $t('shipping') }}
          </div>
          <div v-if="row.trackingNumber" class="text-gray-800">{{ row.trackingNumber }}</div>
          <div class="text-gray-800">{{ orderId }}</div>
          <div class="text-gray-500">{{ dateText }}</div>
        </div>
        <div class="text-right">
          <div class="text-xs text-gray-500">{{$t('total')}}</div>
          <div class="font-semibold text-gray-900">
            {{ totalText }} <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
          </div>
        </div>
      </div>
  
      <!-- grid 2 cols -->
      <div class="grid grid-cols-2 gap-2">
        <!-- Col 1 -->
        <div class="space-y-1">
          <div class="text-xs text-gray-500">{{$t('client')}}</div>
          <div class="font-medium text-gray-900 truncate">{{ customerName }}</div>
          <a class="text-blue-600 text-sm" :href="'tel:' + customerPhone">
            {{ customerPhone }}
          </a>
          <div class="text-xs text-gray-600 capitalize">
            {{ customerCity }}<span v-if="customerCountry">, {{ customerCountry }}</span>
          </div>
  
        


        </div>
  
        <!-- Col 2 -->
        <div class="space-y-2">
            <div>
                <div class="text-xs text-gray-500">{{$t('etat')}}</div>

                <!-- نصّ عادي بنفس ألوان الـ desktop -->
                <button
                    class="mt-2 w-full rounded py-2 border text-sm font-medium text-center bg-transparent"
                    :style="statusBtnStyle"
                    @click="openStatus"
                   
                >
                    {{ statusText }}
                </button>
            </div>

          

  
          <!-- Badges paid/processed (نفس دلالة الديسكتوب) -->
          <div
            v-if="isShippings && (row.status === 'paid' || row.status === 'processed')"
            class="text-2xs inline-block bg-green-600 text-white px-2 py-0.5 rounded"
          >
            {{ row.status === 'paid' ? 'PaidAt' : 'ProcessedAt' }}
            ({{ $moment(row.status === 'paid' ? row.paidAt : row.updatedAt).format('YYYY-MM-DD') }})
          </div>

          <!-- Commentaires / Notes / Téléconsultant -->
          <div v-if="isShippings || isOrders" class="mt-2 space-y-1">
            <!-- Téléconsultant -->
             
            <div v-if="currentUser.type !== 'Courier' && (orderObj && orderObj.teleConsultantConfirm && orderObj.teleConsultantConfirm.fullName) || (row.teleConsultantConfirm && row.teleConsultantConfirm.fullName)" class="flex items-center text-sm text-gray-700 call-post">
              <svg class="fill-current text-gray-700 mr-1 w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"/>
              </svg>

              <span>{{ orderObj ? orderObj.teleConsultantConfirm.fullName : row.teleConsultantConfirm.fullName }}</span>
            </div>

            <!-- Commentaires Order / Notes / Comment -->
            <div v-if="row.notes || row.comment || (orderObj && orderObj.comment)" class="flex flex-col gap-1 text-sm">
              <span v-if="orderObj && orderObj.comment" class="bg-blue-500 text-white px-2 py-1 rounded truncate">
                Call Center: {{ orderObj.comment }}
              </span>
              <span v-if="row.notes" class="bg-blue-500 text-white px-2 py-1 rounded truncate">
                {{ row.notes }}
              </span>
              <span v-if="row.comment" class="bg-blue-500 text-white px-2 py-1 rounded truncate">
                {{ row.comment }}
              </span>
            </div>

            <!-- Price Reduction -->
            <span v-if="row.priceReduction && row.priceReduction.status === 'en attente'" class="bg-orange-500 text-white px-2 py-1 rounded text-sm truncate">
              🕐 Réduction Demandée: {{ row.priceReduction.originalPrice }} → {{ row.priceReduction.proposedPrice }}
            </span>
          </div>

            <!-- ✅ Nouveau champ : Statut de livraison -->
            <div v-if="isOrders && row.shippingStatus && currentUser.type !== 'Seller'">
              <div class="text-xs text-gray-500">Statut de livraison</div>
              <div class="status_liv" v-html="row.shippingStatus ? row.shippingStatus : '—' "></div>
            </div>

        </div>
      </div>

      <div class="w-full">
        <div class="text-xs text-gray-500 mt-2">{{$t('produits')}}</div>

        <!-- bloc productDisplay -->
        <div class="text-gray-900 space-y-0.5">
          <div
            v-for="(p, i) in productDisplay"
            :key="i"
            class="flex items-center justify-between truncate py-1"
          >
            <div class="flex items-center gap-3 truncate">
              <!-- Image avant le nom -->
              <expandable-image
                v-if="p.picture"
                class="expandable-img flex-shrink-0 rounded-md"
                :src="p.picture"
                :alt="p.name"
              />
              <div class="truncate">
                <span class="text-gray-700 mr-1">{{ p.qty }}×</span>
                <span class="truncate font-medium">{{ p.name }}</span>
                <div v-if="p.sku" class="text-xs text-gray-400 truncate">{{ p.sku.toUpperCase() }}</div>
              </div>
            </div>

            <div class="text-sm text-gray-900 ml-2 whitespace-nowrap">
              {{ formatPrice(p.unitPrice) }}
            </div>
          </div>

          <div v-if="hiddenCount > 0" class="text-xs text-gray-500">
            +{{ hiddenCount }} {{ $t('more') || 'more' }}
          </div>
        </div>
      </div>

  
      <!-- Actions -->
      <div v-if="filteredActions.length" class="mt-2 flex gap-2 flex-wrap">
        <button
          v-for="(act, k) in filteredActions"
          :key="k"
          class="px-3 py-2 rounded border flex items-center gap-1"
          @click="onAction(act)"
        >
          <i v-if="act.icone" class="material-icons">{{ act.icone }}</i>
          <span>{{ $t(act.text) }}</span>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'OrderMobileCard',
    props: {
      row: { type: Object, required: true },
      config: { type: Object, required: true },
      idWharhouse: { type: Object, default: null },
      currentUser: { type: Object, default: null },
      getStyleByName: { type: Function, required: true },
      getAccess: { type: Function, required: true },
      getAccessLinks: { type: Function, default: () => () => true }, // اختياري إلا كنت كتستعملو
      index: { type: Number, default: 0 },
    },
    computed: {
      isOrders ()   { return this.config && this.config.name === 'orders' },
      isShippings(){ return this.config && this.config.name === 'shippings' },
  
      orderObj ()   { return (this.row && this.row.orderObjet) ? this.row.orderObjet : null },
  
      // header
      orderId () {
        if (this.row && this.row.id) return this.row.id
        if (this.orderObj && this.orderObj.id) return this.orderObj.id
        return ''
      },
      dateText () {
        const d = (this.row && this.row.date)
          || (this.orderObj && this.orderObj.date)
        return d ? this.$moment(d).format('YYYY-MM-DD') : ''
      },
      totalText () {
        if (this.row && typeof this.row.totalPrice !== 'undefined') return this.row.totalPrice
        if (this.orderObj && typeof this.orderObj.totalPrice !== 'undefined') return this.orderObj.totalPrice
        return 0
      },
  
      // client
      customer () {
        if (this.row && this.row.customer) return this.row.customer
        if (this.orderObj && this.orderObj.customer) return this.orderObj.customer
        return {}
      },
      customerName    () { return this.customer.fullName  || '' },
      customerPhone   () { return this.customer.phone     || '' },
      customerCity    () { return this.customer.city      || '' },
      customerCountry () { return this.customer.country   || '' },
  
      // products
      productDetails() {
        if (this.row && Array.isArray(this.row.details)) return this.row.details
        if (this.orderObj && Array.isArray(this.orderObj.details)) return this.orderObj.details
        return []
      },

      // نحضّرو عناصر قابلة للعرض: { name, qty }
      productItems() {
      return this.productDetails.map(d => {
        const productObj = d.product || {};

        // prix (même logique que toi)
        const unitPrice = (typeof d.unitPrice !== 'undefined' && d.unitPrice !== null)
          ? d.unitPrice
          : (typeof d.price !== 'undefined' ? d.price
            : (productObj.price || productObj.unitPrice || 0));

        // récupération image — priorités communes
        const picture =
          d.picture ||
          productObj.picture ||
          (Array.isArray(productObj.images) && productObj.images[0]) ||
          productObj.thumbnail ||
          productObj.image ||
          null;

        // optional sku/id
        const sku = productObj.sku || productObj.ref || productObj.id_v2 || null;

        return {
          name: (productObj && (productObj.name || productObj.title)) || d.name || this.$t('product') || 'Product',
          qty: typeof d.quantity !== 'undefined' ? d.quantity : (d.qty || 1),
          unitPrice: Number(unitPrice) || 0,
          picture,
          sku
        };
      });
    },


      // نعرضو حتى 2 (ولا بدّل العدد كيف بغيتي)
      productDisplay() {
        const limit = 10
        return this.productItems.slice(0, limit)
      },

      hiddenCount() {
        const limit = 10
        return Math.max(0, this.productItems.length - limit)
      },

      // باقي ديالك:
      productCount () {
        const d1 = (this.row && this.row.details && this.row.details.length) ? this.row.details.length : 0
        const d2 = (this.orderObj && this.orderObj.details && this.orderObj.details.length) ? this.orderObj.details.length : 0
        return d1 || d2
      },
  
      // status
      statusLabel () {
        if (this.isOrders) {
          return (this.row && this.row.status && this.row.status.name) ? this.row.status.name : ''
        }
        return (this.row && this.row.status) ? this.row.status : ''
      },
      statusStyle () {
        return this.getStyleByName ? this.getStyleByName(this.statusLabel) : {}
      },
  
      // actions (نفس النظام ديال الديسكتوب: كنفلتر بحسب getAccess / getAccessLinks)
      filteredActions() {
        const base = (this.config && this.config.actions && this.config.actions.elements) ? this.config.actions.elements : []
        if (!base.length) return []
        // بعض المشاريع كتستعمل getAccessLinks، وبعضها غير getAccess… نساندو الجوج
        return base.filter(act => {
          // شرط link ولا method بحال الديسكتوب
          const allowByLink = this.getAccessLinks ? this.getAccessLinks(act.action || null) : true
          // شرط الدور/الحالة بحال الديسكتوب
          const allowByAccess = this.getAccess
            ? this.getAccess(act.key, this.row.status, this.row.type, act.role, (this.row.lastUnreachedDate || this.row.remind || null))
            : true
          return allowByLink && allowByAccess
        })
      },
      statusText() {
            if (this.isOrders) {
              // orders: غالباً عندك status.name أو status.label
              const s = this.row && this.row.status ? this.row.status : null
              if (!s) return this.$t('etat')
              // استعمل label إن وُجد، وإلا ترجم name
              return s.label || this.$t(s.name === 'Cancelled' ? this.row.validated_status ? 'cancelled_finished' : 'cancelled_callcenter' : s.name) || s.name || this.$t('etat')
            }
            // shippings: status كيكون string
            const s = (this.row && this.row.status) ? this.row.status : null
            return s ? (this.$t(s) || s) : this.$t('etat')
        },
        statusBtnStyle() {
           // ORDERS: عندك status.color
            if (this.isOrders) {
            const c = (this.row && this.row.status && this.row.status.color) ? this.row.status.color : '#16a34a'
            return { color: c, borderColor: c, background: 'transparent' }
            }

            // SHIPPINGS: كنستعمل الماب العامة optionsColors(status)
            const cssStr = this.$f && typeof this.$f.ColorsStatusShippings === 'function'
            ? this.$f.ColorsStatusShippings(this.row && this.row.status)
            : ''

            // Vue كيدعم :style كسلسلة أو object، نخليها كما هي إن كانت صالحة
            if (cssStr && typeof cssStr === 'string') {
            return cssStr + ';background:transparent;'
            }

            // Fallback
           return { color: '#16a34a', borderColor: '#16a34a', background: 'transparent' }
        },
    },
    methods: {
        openStatus() {
           console.log('this.row--------',this.row)
           if (this.row)  this.$emit('open-status', this.row, this.index);
        },
        onAction(act) {
        if (act.link) {
            const to = `${act.link}/${this.row && this.row._id ? this.row._id : ''}`;
            this.$emit('action-link', { to });
            return;
        }
        this.$emit('action', { key: act.key, row: this.row });
        },
        formatPrice(value) {
          const price = Number(value || 0);
          // si idWharhouse contient currency, on l'utilise, sinon 'MAD'
          const currency = (this.idWharhouse && this.idWharhouse.currency) ? this.idWharhouse.currency : 'MAD';
          // ajustar locale si besoin (on peut dériver de currency ou user locale)
          try {
            return price.toLocaleString() + ' ' + this.idWharhouse.currency;
          } catch (e) {
            // fallback simple
            return price.toLocaleString() + ' ' + this.idWharhouse.currency;
          }
  },
    },
  }
  </script>
  
  <style scoped>
  .text-2xs { font-size:.7rem; line-height:1rem; } /* Tailwind v1 helper */
  :deep(.status_liv span) {
  width: 100%;
  text-align: center;
  display: block;
  font-size: 10px;
  padding: 5px;
}

  </style>
  